module.exports={turnstile_modal:{message:"सुरक्षा विवरण का सत्यापन किया जा रहा है"}};